import * as React from "react";
import {observer} from "mobx-react";
import { Wrapper, Lists } from "./components";
import {ListBoardProps} from "./types";
import {ListBoardList} from "./list";
import {RotateLoader} from "../loaders/rotate";

interface State {}

@observer
export class ListBoard<T> extends React.Component<ListBoardProps<T>, State> {

  constructor(props: ListBoardProps<T>) {
    super(props);
  }

  componentDidMount() {
    this.props.fetch();
  }

  render() {

    const { data, columns, renderIcon, renderRow, renderRowDropdown } = this.props;

    const { error, loading } = data;

    if (error) { return <p className="error-text">Something went wrong, refresh the page and try again</p>; }

    if (loading) { return <RotateLoader size={4}/>; }

    return (
      <Wrapper>
        {columns.map((column, i) => {
          if (column.lists.length === 1 && column.lists[0].hide) {
            return null;
          }
          return (
            <Lists key={i}>
              {column.lists.map((list, k) => {
                return (
                  <ListBoardList<T>
                    key={k}
                    data={data}
                    list={list}
                    renderIcon={renderIcon}
                    renderRow={renderRow}
                    renderRowDropdown={renderRowDropdown}
                  />
                );
              })}
            </Lists>
          );
        })}
      </Wrapper>
    );
  }

}
